import(/* webpackMode: "eager" */ "/codebuild/output/src3912945979/src/kenshoku-bank/nextjs/node_modules/next/dist/client/link.js");
